import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../Auth';
export default function useEntity(url, id, initialData) {
    const [api] = useAuth();
    const [data, setData] = useState(initialData || {});
    const [loading, setLoading] = useState(false);
    const applyData = useCallback(function (newData) {
        setData(newData.apply ? newData : (data => (Object.assign(Object.assign({}, data), newData))));
    }, [setData]);
    const update = useCallback(async function () {
        setLoading(true);
        try {
            const response = await api.tokenized.get(url + "/" + id);
            setData(response.data || initialData || {});
        }
        finally {
            setLoading(false);
        }
    }, [api, data, loading, url, id, initialData]);
    const save = useCallback(async function () {
        setLoading(true);
        try {
            const response = await (id ?
                api.tokenized.patch(url + "/" + id, data) :
                api.tokenized.put(url, data));
            setData(response.data);
            return response.data;
        }
        finally {
            setLoading(false);
        }
    }, [api, data, loading, url, id]);
    useEffect(function () {
        if (!data || data.id != id) {
            update();
        }
    }, [url, id]);
    return [
        data,
        applyData,
        save,
        loading
    ];
}
